import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import useUrlSearchParams from '@/hooks/useUrlSearchParams'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getResources } from '../../../services'
import { getResourceColumns } from './columns'
import { Resource } from '../../../types'

const ResourcesList = () => {
    const { t } = useTranslation()

    const { queryParams, searchInputProps } = useUrlSearchParams()

    const apiParams = useMemo(
        () => ({
            name: queryParams.q || undefined,
            max: 1000,
        }),
        [queryParams.q]
    )

    const {
        data: resourcesData,
        renderState,
        isFetching,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.AUTHORIZATION_RESOURCES, apiParams],
            queryFn: () => getResources(apiParams),
            placeholderData: true,
        },
        { showLoading: true, showError: true }
    )

    const rows = resourcesData?.results || []
    const columns = useMemo(() => getResourceColumns(), [])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Paper>
            <DataTableCustomized<Resource>
                columns={columns}
                rows={rows}
                rowKey={(row) => row._id || row.id}
                isFetching={isFetching}
                emptyMessage={t('noData', 'Không có dữ liệu')}
                pagination={{
                    page: 1,
                    pageSize: 20,
                    total: rows.length,
                }}
                toolbar={{
                    search: {
                        ...searchInputProps,
                        placeholder: t('search'),
                    },
                }}
                bordered
            />
        </Paper>
    )
}

export default ResourcesList
